import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  // Do nothing if user is not logged in
  if (!auth.authenticated) {
    return next(req);
  }

  // Only attach token to the backend API
  const isApiCall = req.url.startsWith(environment.apiBaseUrl);
  if (!isApiCall) {
    return next(req);
  }

  return from(auth.refreshToken(30)).pipe(
    catchError((err) => {
      console.error('Token refresh failed', err);
      return of(false);
    }),
    switchMap(() => {
      const token = auth.token;

      const authReq = token
        ? req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          })
        : req;

      return next(authReq);
    })
  );
};